import authRedux from '../../auth/redux/reducer'

//export redux objects
export default {
	authRedux
};
